<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.versionCode"
                selectType="selectSearch"
                :setParams="{ id: queryParams.basicDataId }"
                requestApi="/scp/scpSopBasicData/versionList"
                :selectItem="{ value: 'selectedValue', label: 'realValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="说明">
              <a-input :disabled="true" v-model="queryParams.description"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商类别">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.sopSupplierCategory"
                :dropdown-match-select-width="false"
                selectType="selectFilter"
                :selectData="sopSupplierCategoryList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="供应商名称">
                <global-select
                  :value.sync="queryParams.sopSupplierName"
                  :dropdown-match-select-width="false"
                  selectType="selectAssembleMultipleSearch"
                  requestApi="/mdm/mdmOrgSupplier/supplierNameList"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  searchParam="supplierName" />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="工艺大类">
                <global-select
                  :max-tag-count="2"
                  :max-tag-text-length="4"
                  show-search
                  :value.sync="queryParams.scpProductBroadCategory"
                  :dropdown-match-select-width="false"
                  selectType="selectFilter"
                  :selectData="scpProductBroadCategoryList"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="getTableInfo" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:scpSopSupplierCapacity:export']"
      >导出</a-button>
      <a-button @click="$refs.importData.show()" type="primary" v-hasPermi="['scp:scpSopSupplierCapacity:import']"
      >导入</a-button>
      <a-button @click="handleTemplate" v-hasPermi="['scp:scpSopSupplierCapacity:download']">下载模版</a-button>
      <a-button :loading="isSynchronous" @click="handleSynchronous">同步</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">

          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="detailId"
            :scroll="{ fixScreen: true, x: 1300 }"
          >
            <span slot="operation" slot-scope="{ record,$index,column }">
              <a v-if="!isEdit || currentId !== record.keyId" @click="handleEdit(record,$index)">编辑</a>
              <!-- <a v-if="!isEdit || currentId !== record.keyId" class="ml10" @click="handleDelete(typeList, record)">删除</a> -->
              <a v-if="isEdit && currentId === record.keyId" @click="handleSave(record,column)">保存</a>
              <a v-if="isEdit && currentId === record.keyId" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <!-- 平均活动价 -->
            <template slot="averageActivityPrice" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.keyId">{{ record.averageActivityPrice }}</span>
              <a-input-number v-if="isEdit && currentId === record.keyId" v-model="record.averageActivityPrice" size="small" />
            </template>
            <!-- 版本说明 -->
            <template slot="versionDescription" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.keyId">{{ record.versionDescription }}</span>
              <a-input v-if="isEdit && currentId === record.keyId" v-model="record.versionDescription" size="small" />
            </template>
            <!-- 物料编码 -->
            <template slot="itemCode" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.keyId">{{ record.itemCode }}</span>
              <a-input v-if="isEdit && currentId === record.keyId" v-model="record.itemCode" size="small" />
            </template>

            <!-- 月份 -->
            <template slot="month" slot-scope="{ record, column }">
              <!-- <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex].dateValue+column.myTitle.includes('利用率')?'%':'' }}</span> -->
              <span v-if="!isEdit || currentId !== record.keyId">{{ record[column.dataIndex].dateValue + (column.myTitle.includes('利用率')?'%':'') }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.keyId"
                v-model="record[column.dataIndex].dateValue"
                size="small"
                :min="0"
              />

              <!-- <a-button @click="handleInputChange(record, column)"> 测试</a-button> -->
            </template>
            <template slot="monthOnlyShow" slot-scope="{ record, column }">
              <!-- <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex].dateValue+column.myTitle.includes('利用率')?'%':'' }}</span> -->
              <span v-if="!isEdit || currentId !== record.keyId">{{ record[column.dataIndex].dateValue + (column.myTitle.includes('利用率')?'%':'') }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.keyId"
                v-model="record[column.dataIndex].dateValue"
                size="small"
                :min="0"
              />
            </template>

            <template slot="isStopFlag" slot-scope="{ record }">
              <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
            </template>
          <!-- <div
            v-for="item in monthColumns1"
            :slot="item.dataIndex"
            slot-scope="{record}"
            :key="item.dataIndex"
          >
            <a-input v-model="record.versionCode"></a-input>
          </div> -->
          </ls-api-table>
        </a-spin>
      </div>
      <import-data
        ref="importData"
        :url="url"
        :sopDfcBasicDataId="queryParams.basicDataId"
        @handle-success="handleOk"
      />
    </template>
  </ls-table-layout>
</template>

  <script>
  import {
    apiScpSopSupplierCapacityUpdateCapacity,
    scpDelSopSupplierCapacity
  } from '@/api/scp/new-product-forecast/new-product-forecast'
  import {
    apiScpSopSupplierCapacityList,
    apiSendScpFcSporadic
  } from '@/api/scp/general-parameter-settings/supplier-capacity.js'
  import ImportData from './components/ImportData'
  import { generateLsTableResData } from '@/utils/util.js'

  export default {
    // eslint-disable-next-line
    name: 'detail', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
    components: {
      ImportData
    },
    data () {
      return {
        isSynchronous: false,
        url: '/scp/scpSopSupplierCapacity/import',
        isLoading: false,
        tableList: [],
        scpProductBroadCategoryList: [], // 工艺大类
        sopSupplierCategoryList: [], // 供应商类别
        monthColumns1: [
          {
            title: '版本',
            width: 140,
            fixed: 'left',
            dataIndex: 'month0',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '版本说明',
            fixed: 'left',
            dataIndex: 'month1',
            scopedSlots: { customRender: 'versionDescription' },
            width: 140,
            align: 'center'
          }
        ],
        monthColumns: [],
        isSetTitle: false,
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiScpSopSupplierCapacityList, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
           // 版本
          versionCode: undefined,
          basicDataId: undefined,
          scpProductBroadCategory: undefined,
          sopSupplierCategory: undefined,
          sopSupplierName: undefined,
          description: undefined
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        columns: [],
        columnsServe: [],
        // 表格字段
        columnsNative: [
          // {
          //   title: '版本',
          //   width: 120,
          //   fixed: 'left',
          //   dataIndex: 'versionCode',
          //   ellipsis: true,
          //   align: 'center'
          // },
          {
            title: '供应商类别',
            fixed: 'left',
            ellipsis: true,
            dataIndex: 'sopSupplierCategory',
            width: 140,
            align: 'center'
          },
          {
            title: '供应商名称',
            fixed: 'left',
            ellipsis: true,
            dataIndex: 'sopSupplierName',
            width: 200,
            align: 'center'
          },
          // {
          //   title: '战略等级',
          //   fixed: 'left',
          //   ellipsis: true,
          //   dataIndex: 'serialNumber',
          //   width: 100,
          //   align: 'center'
          // },
          {
            title: '工艺大类',
            width: 180,
            fixed: 'left',
            ellipsis: true,
            dataIndex: 'scpProductBroadCategoryDesc',
            align: 'center'
          }
          // ,
          //   {
          //   title: '操作',
          //   width: 100,
          //   fixed: 'right',
          //   align: 'center',
          //   dataIndex: 'operation',
          //   scopedSlots: { customRender: 'operation' }
          //   }
        ],
        unitOfMeasureList: [],
        unitOfMeasureListNew: []
      }
    },
    created () {
       // this.queryParams.forecastName = this.$route.params.forecastName;
       // this.queryParams.versionCode = this.$route.params.versionCode;
       this.columns = this.columnsNative
       this.queryParams.basicDataId = this.$route.query.id; // 从路由参数中获取 id 值
        this.queryParams.description = this.$route.query.description; // 从路由参数中获取 id 值
        this.queryParams.versionCode = this.$route.query.versionCode; // 从路由参数中获取 id 值
        this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'scpProductBroadCategoryList');
        this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'sopSupplierCategoryList');
        this.basicDataId = this.queryParams.basicDataId;
        this.versionCode = this.queryParams.versionCode;
        this.description = this.queryParams.description;
    },
    mounted () {
      this.getTableInfo()
    },
    methods: {
      handleSynchronous () {
        this.isSynchronous = true
        const self = this
        apiSendScpFcSporadic({ basicDataId: this.queryParams.basicDataId }).then(response => {
          this.isSynchronous = false
            if (response.code === 200) {
              self.$message.success('同步成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          }).catch((e) => {
            this.isSynchronous = false
          })
      },
            /** 下载模板操作 */
      handleTemplate () {
      this.download('scp/scpSopSupplierCapacity/download', {
        basicDataId: this.queryParams.basicDataId
      }, `供应商产能列表模版_${new Date().getTime()}.xlsx`)
    },
      handleInputChange (record, dataIndex) {
        const myTitle = dataIndex.myTitle
        myTitle.includes('利用率')
        // debugger
      },
      handleDelete (tableList, record) {
        const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          scpDelSopSupplierCapacity(record.lineIds).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
      },
      // handleOperation (text, record) {
      //   this.$router.push({ path: `/salesForecast/detail/` })
      // },
      handleNameChange (val, selectList) {
        const filteredItem = selectList.filter(item => item.realValue === val);
        this.queryParams.startMonth = filteredItem[0].bringOutDataOne
      },
      handleVersionChange (val, selectList) {
      //   const filteredItem = selectList.filter(item => item.realValue === val);
      //  this.queryParams.versionDescription = filteredItem[0].bringOutDataOne
        if (val) {
          const filteredObject = selectList.filter(obj => obj.selectedValue === val);
          this.queryParams.versionCode = filteredObject[0].realValue
          this.queryParams.basicDataId = filteredObject[0].selectedValue
          this.queryParams.description = filteredObject[0].label
          this.basicDataId = this.queryParams.basicDataId;
          this.versionCode = this.queryParams.versionCode;
          this.description = this.queryParams.description;
        }
      },
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        this.download('scp/scpSopSupplierCapacity/export', {
          ...this.queryParams
        }, `供应商产能列表_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record, index) {
        if (this.currentId && record.keyId !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.keyId;
      },
       findItem (columns, key) {
        for (let i = 0; i < columns.length; i++) {
          const item = columns[i];
          if (item.indexKey === key) {
            return item;
          } else if (item.children) {
            const found = this.findItem(item.children, key);
            if (found) {
              return found;
            }
          }
        }
        return null;
      },
      // 编辑-保存 检测有children的保存
      handleSave (record) {
        console.log(this.columns, 'column')
        let isNoEdit = false
        let title = ''
        for (const key in record) {
            if (key.includes('month') && (record[key].dateValue === '' || record[key].dateValue === undefined || record[key].dateValue === null)) {
              isNoEdit = true
              const foundItem = this.findItem(this.columnsServe, key);
              title = title + foundItem.indexName + ','
          }
        }
        if (isNoEdit) {
            this.$message.error(title + '列为空，保存失败')
            return
          }
        const supplierCapacityList = []
        const mapKey = ['amount', 'guaranteedEquity', 'guaranteeUtilizeRate', 'standardUtilizeRate', 'maxUtilization']
        for(const item of this.columns) {
          if(item.children) {
            let obj = {
              month: item.title
            }
            for (const chid of item.children) {
              if(/^month/.test(chid.dataIndex)) {
                let number = this.regByMonth(chid.dataIndex, item.dataIndex)
                number = number - 1
                if (number !== false) {
                  const num = record[chid.dataIndex]?.dateValue || 0
                  const calculate = {
                    'amount': () => parseFloat((num * 10000).toPrecision(12)),
                    'guaranteedEquity': () => parseFloat((num * 10000).toPrecision(12)),
                    'guaranteeUtilizeRate': () => parseFloat((num / 100).toPrecision(12)),
                    'standardUtilizeRate': () => parseFloat((num / 100).toPrecision(12)),
                    'maxUtilization': () => parseFloat((num / 100).toPrecision(12))
                  }
                  obj = {
                    ...obj,
                    id: record[chid.dataIndex]?.id,
                    [mapKey[number]]: calculate[mapKey[number]]()
                  }
                }
              }
            }
            if(Object.keys(obj).length > 1) {
              supplierCapacityList.push(obj)
            }
          }
        }
        // let index = 0
        // let obj ={}
        // let mapkey = ['amount', 'guaranteeUtilizeRate', 'standardUtilizeRate', 'maxUtilization']
        // for(let key in record){
        //   if(/^month/.test(key)){
        //
        //   }
        // }
        const params = {
          ...record,
          supplierCapacityList
        }
        apiScpSopSupplierCapacityUpdateCapacity(params).then((response) => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
      },
      // 匹配字符
      regByMonth(child, parent) {
        // 构建正则表达式，允许在 b 后面有任意字符，但捕获数字部分
        const regex = new RegExp(`^${parent}.*?(\\d+)`);

     // 使用正则表达式匹配字符串 a
        const match = child.match(regex);

        if (match) {
          // 提取匹配结果中的数字部分
          return match[1]
        } else {
         return false
        }
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      },
      getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
      },
      getTableInfo () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      if (this.isLoading) {
        return
      }
      this.$refs.dataTable.myPagination.current = 1
      this.isLoading = true
      apiScpSopSupplierCapacityList({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 }).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          this.tableList.forEach((obj, index) => {
            obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
          })
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.title
          this.columnsServe = response.title
          // 生成新的对象数组，并为每个对象添加name属性
          // const newArray = titles.map((title) => {
          //   return {
          //     title: title.indexName,
          //     dataIndex: title.indexKey,
          //     scopedSlots: { customRender: 'month' },
          //     width: 120,
          //     align: 'center'
          //   }
          // })

         const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              dataIndex: title.indexKey,
              children: title.children.map((childrenTitle) => {
                return {
                          title: childrenTitle.indexName,
                          dataIndex: childrenTitle.indexKey,
                          scopedSlots: { customRender: childrenTitle.indexName.includes('金额') ? 'monthOnlyShow' : 'month' },
                          width: 120,
                          myTitle: childrenTitle.indexName,
                          align: 'center'
                        }
              })
            }
          })
          console.log('newArray', newArray)
          const dynamicColumn = this.setNewColumn('scpProductBroadCategoryDesc', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.columns.push({
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 120,
            fixed: 'right'
          })
          this.$refs.dataTable.myPagination.total = response.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
           // 版本
          basicDataId: this.basicDataId,
          versionCode: this.versionCode,
          description: this.description,
          scpProductBroadCategory: undefined,
          sopSupplierCategory: undefined,
          sopSupplierName: undefined
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
          /**
     * 在table 某个列的字段后增加列
     * key：列的字段名称
     * columnList 列表的列
     * insertColumnList 插入的新列
     *  */
    setNewColumn (key, columnList, insertColumnList) {
      const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
      const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
      if (index !== -1) {
        newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
      }
      return newArray
    }
    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
